import React from 'react'
import { Link } from 'react-router-dom'
import { IMarketplaceProductPromotion } from '@scentregroup/shared/types'
import { Heading, CallToAction } from '@scentregroup/ui'
import trackMkpEvent, { labels } from '../../lib/market-place-track-event'
import CartProductItem, { ICartProductItem } from '../cart-product-item'
import ButtonRow from '../button-row'
import { CART } from '../../paths'
import Dialog from '../dialog'
import style from './index.module.scss'

export interface IAddToCartDialog extends ICartProductItem {
  isOpen: boolean
  onViewCart?: () => void
  onContinueShopping: () => void
  applicablePromotions?: IMarketplaceProductPromotion[]
}

const AddToCartDialog: React.FunctionComponent<
  React.PropsWithChildren<IAddToCartDialog>
> = ({ isItemLinked = true, ...props }: IAddToCartDialog) => {
  const { isOpen, onViewCart, onContinueShopping } = props
  const titleId = 'add-to-cart-dialog'

  return (
    <Dialog
      isOpen={isOpen}
      onDismissButtonClick={() => {
        onContinueShopping()
        trackMkpEvent.clicked(labels.CLOSE_DIALOG_BOX)
      }}
      a11y={{ labelledby: titleId }}
    >
      <Heading type="small" className={style.heading} id={titleId}>
        Items added to cart
      </Heading>
      <div className={style.cartProductItem}>
        <CartProductItem isItemLinked={isItemLinked} {...props} />
      </div>
      <ButtonRow>
        <CallToAction
          data-test-id="view-cart-btn"
          aria-label="View cart"
          element={Link}
          to={CART}
          onClick={() => {
            onViewCart?.()
            trackMkpEvent.clicked(labels.GO_TO_CART)
          }}
        >
          VIEW CART
        </CallToAction>
        <CallToAction
          data-test-id="continue-shopping-btn"
          aria-label="Continue shopping"
          inferior
          onClick={() => {
            onContinueShopping()
            trackMkpEvent.clicked(labels.CONTINUE_SHOPPING)
          }}
        >
          CONTINUE SHOPPING
        </CallToAction>
      </ButtonRow>
    </Dialog>
  )
}

export default AddToCartDialog
